import React from 'react';
import configHelper from 'helpers/config';
import styled from 'styled-components';

const StyledLabelWrapper = styled.div`
    margin: 0 auto 10px 10px;
    color: RGBA(255,255,255, .7);
    font-size: 12px;
    text-align: center;
`;

const AppVersion = () => {
    return (
        <StyledLabelWrapper>
            <span>v{ configHelper.getAppVersion() }</span>
        </StyledLabelWrapper>
    );
};

export default AppVersion;



// WEBPACK FOOTER //
// ./src/components/menus/AppVersion/AppVersion.js